/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgBookRead = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgBookRead"
    {...props}
  >
    {props.children}
    <path
      stroke="#0d0d0d"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.333 20-.083-.125c-.579-.868-.868-1.302-1.25-1.617a3.3 3.3 0 0 0-1.149-.614c-.473-.144-.995-.144-2.039-.144H4.667c-.934 0-1.4 0-1.757-.182a1.67 1.67 0 0 1-.728-.728C2 16.234 2 15.767 2 14.833V7.667c0-.934 0-1.4.182-1.757.16-.314.414-.569.728-.728C3.267 5 3.733 5 4.667 5H5c1.867 0 2.8 0 3.513.363.628.32 1.137.83 1.457 1.457.363.713.363 1.646.363 3.513m0 9.667v-9.667m0 9.667.084-.125c.579-.868.868-1.302 1.25-1.617a3.3 3.3 0 0 1 1.148-.614c.474-.144.996-.144 2.04-.144H16c.933 0 1.4 0 1.757-.182.313-.16.568-.414.728-.728m-8.152-6.257c0-1.867 0-2.8.364-3.513.32-.627.83-1.137 1.456-1.457C12.866 5 13.8 5 15.667 5H16c.933 0 1.4 0 1.757.182 0 0 .424.181.576.318M22 15l-1.5-1.5m1-2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
    />
  </svg>
)
